import React from 'react';

class ChangeLogTable extends React.Component {
    render() {
        const headings = this.props.headings;
        const data = this.props.data;

        return(
            <table>
                <thead>
                    <tr>
                        {headings.map((header, index) => (
                            <th key={index} >{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((record, index) => (
                        <tr key={index}>
                            <td>{record.created}</td>
                            {(record.platform) && (
                                <td>{record.platform}</td>
                            )}
                            <td>{record.path}</td>
                            <td className="break">{record.oldValue}</td>
                            <td className="break">{record.newValue}</td>
                            <td>{record.username}</td>
                            <td>{record.taskId}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )
    }
}
export default ChangeLogTable;


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/ChangeLogTable.js